import React, { useContext, useState } from "react";
import "./Login.css";
import { AuthContext } from "../../context/AuthContext.js";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [isRegister, setIsRegister] = useState(false);
  const [credentials, setCredentials] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
  });

  const [result, setResult] = useState(null);
  const { loading, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const handleClick = async (e) => {
    e.preventDefault();

    if (isRegister) {
      // Register
      if (!credentials.name || !credentials.username || !credentials.email || !credentials.password) {
        setResult("❌ Please fill in all fields");
        return;
      }

      try {
        await axios.post("/auth/register", credentials);
        setResult("✅ Registration successful! You can now login.");
        setIsRegister(false);
      } catch (err) {
        setResult("❌ " + (err.response?.data?.message || "Registration failed"));
      }
    } else {
      // Login
      if (!credentials.username || !credentials.password) {
        setResult("❌ Please fill in username and password");
        return;
      }

      dispatch({ type: "LOGIN_START" });
      try {
        const res = await axios.post("/auth/login", {
          username: credentials.username,
          password: credentials.password,
        });
        dispatch({ type: "LOGIN_SUCCESS", payload: res.data.details });
        navigate("/");
        setResult("✅ Login successful: " + res.data.details.username);
      } catch (err) {
        dispatch({
          type: "LOGIN_FAILURE",
          payload: err.response?.data || { message: "Something went wrong" },
        });
        setResult("❌ " + (err.response?.data?.message || "Login failed"));
      }
    }
  };

  return (
    <div className="login">
      <div className="lContainer">
        <h2>{isRegister ? "Register" : "Login"}</h2>

        {isRegister && (
          <input
            type="text"
            placeholder="Name"
            id="name"
            onChange={handleChange}
            className="lInput"
          />
        )}

        <input
          type="text"
          placeholder="Username"
          id="username"
          onChange={handleChange}
          className="lInput"
        />

        {isRegister && (
          <input
            type="email"
            placeholder="Email"
            id="email"
            onChange={handleChange}
            className="lInput"
          />
        )}

        <input
          type="password"
          placeholder="Password"
          id="password"
          onChange={handleChange}
          className="lInput"
        />

        <button onClick={handleClick} disabled={loading} className="lButton">
          {loading ? "Loading..." : isRegister ? "Register" : "Login"}
        </button>

        {result && <p className="result">{result}</p>}

        <p className="toggleForm">
          {isRegister ? (
            <>
              Already have an account?{" "}
              <span onClick={() => setIsRegister(false)}>Login</span>
            </>
          ) : (
            <>
              Don't have an account?{" "}
              <span onClick={() => setIsRegister(true)}>Register</span>
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default Login;






